module.exports = __webpack_public_path__ + "static/media/icon_gold.4aa994bd.svg";